require('./_wks-define')('asyncIterator');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/core-js/2.4.0/core-js/modules/es7.symbol.async-iterator.js
 ** module id = 491
 ** module chunks = 0
 **/